import { render } from "./SetAlertChannels.vue?vue&type=template&id=6a0f06bc"
import script from "./SetAlertChannels.vue?vue&type=script&lang=js"
export * from "./SetAlertChannels.vue?vue&type=script&lang=js"

import "./SetAlertChannels.vue?vue&type=style&index=0&id=6a0f06bc&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__